import { render } from "./Trash-Icon.vue?vue&type=template&id=6b73ffb8&scoped=true&ts=true"
import script from "./Trash-Icon.vue?vue&type=script&lang=ts"
export * from "./Trash-Icon.vue?vue&type=script&lang=ts"

import "./Trash-Icon.vue?vue&type=style&index=0&id=6b73ffb8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b73ffb8"]])

export default __exports__